export default function StockIndicator({ stock, trackInventory }) {
  if (!trackInventory) return <span style={{ color: '#7a5c4a', fontSize: 12 }}>Not tracked</span>;

  let dotColor, label;
  if (stock === 0) { dotColor = '#dc3545'; label = 'Out of stock'; }
  else if (stock <= 10) { dotColor = '#e8a020'; label = `${stock} in stock`; }
  else { dotColor = '#4a7358'; label = `${stock} in stock`; }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
      <div style={{ width: 7, height: 7, borderRadius: '50%', background: dotColor, flexShrink: 0 }} />
      <span style={{ color: dotColor === '#dc3545' ? '#dc3545' : '#3d2b1f', fontWeight: stock <= 10 ? 700 : 400 }}>{label}</span>
    </div>
  );
}
